export enum ReportType {
    tableByGroup = 1,
    tableSummaryAndDetail = 2,
    tableConfirmInvalidDetail = 3,
    tableDetail = 4
}